import { TDevice } from '$app/constants/common'
export const SIZE = 20
export const ID = 'device'
export type Namespaces = TDevice
